// extracted by mini-css-extract-plugin
export default {"StakeholdersInfoDialog":"ADd14VQpWcNqgp1z5Jj2rg==","stakeholdersData":"J4LQ8woNY3KcCbtf4bgjUg=="};